/**
 * Returns true if the given path is an ancestor or exact match of the current page location.
 *
 * @param menuUrl Path to check (e.g. '/help', '/about', '/').
 * @returns True if current location matches or is a descendant of menuUrl.
 */
export function isAncestorPath(menuUrl: string): boolean {
  if (!menuUrl) return false

  const currentPath = globalThis.location.pathname

  if (currentPath === menuUrl) return true

  // Normalize URLs (remove trailing slashes)
  const normalize = (url: string) =>
    typeof url === 'string' ? url.replace(/\/$/, '') : ''
  const normalizedMenuUrl = normalize(menuUrl)
  const normalizedPath = normalize(currentPath)

  // Special case: '/' matches only root
  if (normalizedMenuUrl === '/') {
    return normalizedPath === '/' || normalizedPath === ''
  }
  if (normalizedMenuUrl === '') return false
  if (normalizedPath === normalizedMenuUrl) return true
  if (
    normalizedPath.startsWith(normalizedMenuUrl + '/') &&
    normalizedMenuUrl.length > 0
  ) {
    return true
  }
  return false
}
